import { useEffect, useState } from "react";
import Cookies from "universal-cookie";
import { getMetaData } from "../api";
import { NAME, ROLE } from "../config";
import Spinner from "../components/loader/Spinner";
import UserPunches from "./WFH/UserPunches";
import LandingPageTabs from "./LandingPageTabs.jsx";
import DashboardWidget from "../components/dashboard/DashboardWidget.jsx";
import { CalendarIcon, ClockIcon, HomeIcon } from "@heroicons/react/solid";

const cookies = new Cookies();
function Dashboard() {
  let name = cookies.get(NAME);
  console.log(cookies);

  const [role, setRole] = useState();
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const refreshMetaData = () => {
    setIsLoading(true);
    getMetaData()
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setRole(cookies.get(ROLE));
    if (cookies.get(ROLE) === "EMPLOYEE") {
      return;
    }
    refreshMetaData(); // Initial data fetch
  }, []);

  return (
    <div>
      <div className="h-full flex items-center w-full pt-8 mb-10 pl-5">
        <div className="h-12 w-1 bg-gradient-to-b from-[#00421f] to-[#00a84f] rounded-full  mr-3"></div>
        <p className="text-3xl font-semibold text-primary ">
          {name && <p> Hi, {name} </p>}
        </p>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="px-4">
          {cookies.get(ROLE) === "EMPLOYEE" ? (
            <>
              <UserPunches data={data} />
            </>
          ) : cookies.get(ROLE) === "consultant" ? (
            <div>
              <div className="grid grid-cols-4 gap-x-4">
                <DashboardWidget
                  icon={CalendarIcon}
                  label="Pending Other Leaves"
                  count={data?.pending_ol_leave}
                  link="/other-leave-approvals"
                />
                <DashboardWidget
                  icon={CalendarIcon}
                  label="Discretionary Leaves Available"
                  count={data?.pending_dl_leave}
                  link="/discretionary-leave-approvals"
                />
              </div>
            </div>
          ) : (
            <div className="grid grid-cols-4 gap-4">
              <DashboardWidget
                icon={CalendarIcon}
                label="Pending Leave Approvals"
                count={data?.pending_leave}s
                showLabelAtBottom={false}
                link="/leave-applied"
              />
              <DashboardWidget
                icon={HomeIcon}
                label="Remote Work Approvals"
                count={data?.pending_wfh}
                showLabelAtBottom={false}
                link="/work-from-home-approval"
              />
              <DashboardWidget
                icon={ClockIcon}
                label="Pending Regularisation"
                count={data?.pending_regularisation}
                showLabelAtBottom={false}
                link="/regularization-requests"
              />
              
            </div>
          )}
        </div>
      )}
      {role === "COMPANY_ADMIN" && (
        <LandingPageTabs refreshMetaData={refreshMetaData} />
      )}
    </div>
  );
}

export default Dashboard;
